import { Grid } from '@mui/material'
import React, { useEffect } from 'react'
import Servicedetail1 from '../servicedetail/Servicedetail1';
import Servicedetail2 from '../servicedetail/Servicedetail2';
import Servicedetail3 from '../servicedetail/Servicedetail3';
import Servicedetail4 from '../servicedetail/Servicedetail4';
import Servicedetail5 from '../servicedetail/Servicedetail5';
import Servicedetail6 from '../servicedetail/Servicedetail6';
import Servicedetail7 from '../servicedetail/Servicedetail7';
import Footer from '../Footer';

const Servciedetailhome = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Grid>
      <Servicedetail1 />
      <Servicedetail2 />
      <Servicedetail3 />
      <Servicedetail4 />
      {/* <Servicedetail5/> */}
      {/* <Servicedetail6/> */}
      <Servicedetail7 />
      <Footer />
    </Grid>
  )
}

export default Servciedetailhome